// extracted by mini-css-extract-plugin
export default {"submitButton":"VoucherSelect_modal_submitButton__shYxt"};